@import 'styles/variables';

.banner {
  display: flex;
  padding: 9px;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  background: linear-gradient(90deg, #d5dcf8 0%, #efdffd 100%), #fff;
  box-shadow: 1px 1px 0 0 #f8f1ff inset, 0 1px 8px 0 rgba(0, 0, 0, 0.09);
  position: relative;
  transform: translateY(0);
  transform-origin: top center;
  margin-bottom: 0;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out, margin-bottom 0.3s ease-out;

  &.closing {
    opacity: 0;
    transform: translateY(-40px);
    margin-bottom: -46px;
  }
}

.progressSection {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progressText {
  color: var(--Dark-80, rgba(0, 0, 0, 0.8));
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: 0.42px;
  white-space: nowrap;
}

.circularProgress {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  margin-left: 8px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1 0 0;
}

.nextUpSection {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nextUpText {
  color: var(--Dark-80, rgba(0, 0, 0, 0.8));
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: 0.42px;
  white-space: nowrap;
}

.seeAllButton {
  background: transparent !important;

  &:hover {
    background: rgba(0, 0, 0, 0.08) !important;
  }

  &:focus {
    background: transparent !important;
  }

  &:active {
    background: rgba(0, 0, 0, 0.12) !important;
  }
}

.closeButton {
  background: transparent;
  padding: 6px;
  border-radius: 4px;
  color: var(--dark-80);
  height: 32px;
  min-width: 32px;
  margin-left: 10px;
  transition: all 0.15s ease;

  svg {
    color: var(--dark-80);
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
    color: var(--dark-80);
  }

  &:active {
    background: rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: $phoneMaxWidth) {
  .banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
  }

  .content {
    gap: 8px;
  }
}
